module.exports = __webpack_public_path__ + "static/media/29BDOS28.cf1a5eb1.jpg";